import { Link } from 'react-router-dom';
import { Search, MapPin } from 'lucide-react';

export default function Header() {
  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center text-white font-bold text-xl">
              UD
            </div>
            <span className="text-xl font-bold text-gray-900">UdaipurDeals</span>
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/offers" className="text-gray-700 hover:text-red-600 font-medium">
              All Offers
            </Link>
            <Link to="/restaurants" className="text-gray-700 hover:text-red-600 font-medium">
              Restaurants
            </Link>
          </nav>

          {/* Location */}
          <div className="flex items-center space-x-2 text-gray-700">
            <MapPin className="w-5 h-5" />
            <span className="hidden sm:inline">Udaipur</span>
          </div>
        </div>
      </div>
    </header>
  );
}
